import { ThankyouComponent } from './thankyou/thankyou.component';
import { BackComponent } from './back/back.component';
import { routes } from './routes';
import { BrowserModule } from '@angular/platform-browser';
import { NgModule } from '@angular/core';
import { BrowserAnimationsModule } from '@angular/platform-browser/animations';
import { RouterModule } from '@angular/router';
import { HttpClientModule } from '@angular/common/http';
import { FormsModule } from '@angular/forms';
import { NgbProgressbarModule, NgbCarouselModule, NgbModalModule } from '@ng-bootstrap/ng-bootstrap';
import {MatProgressSpinnerModule} from '@angular/material/progress-spinner';

import { AppComponent } from './app.component';
import { TopNavigationComponent } from './top-navigation/top-navigation.component';
import { LandingComponent } from './landing/landing.component';
import { ActionComponent } from './action/action.component';
import { HowMuchComponent, ModalContentComponent } from './how-much/how-much.component';
import { BusResComponent, ModalContentComponentBusRes } from './bus-res/bus-res.component';
import { WitnessPromptComponent } from './witness-prompt/witness-prompt.component';
import { HowOftenComponent } from './how-often/how-often.component';
import { ZipComponent } from './zip/zip.component';


@NgModule({
  declarations: [
    AppComponent,
    TopNavigationComponent,
    LandingComponent,
    ActionComponent,
    BusResComponent,
    HowMuchComponent,
    ModalContentComponent,
    ModalContentComponentBusRes,
    WitnessPromptComponent,
    BackComponent,
    ThankyouComponent,
    HowOftenComponent,
    ZipComponent
  ],
  imports: [
    BrowserModule,
    BrowserAnimationsModule,
    HttpClientModule,
    RouterModule.forRoot(routes),
    FormsModule,
    NgbProgressbarModule,
    NgbCarouselModule,
    NgbModalModule,
    MatProgressSpinnerModule
  ],
  entryComponents: [ModalContentComponent],
  providers: [],
  bootstrap: [AppComponent]
})
export class AppModule { }
